module.exports = __webpack_public_path__ + "img/2en.906b0b78.jpg";